export default __webpack_public_path__ + "static/media/myphoto.39d4e19f.png";